document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.fenx-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const openBtn = document.querySelector('[data-fenx-drawer-open]');
  const closeBtn = document.querySelector('[data-fenx-drawer-close]');
  const drawer = document.querySelector('[data-fenx-drawer]');
  const overlay = document.querySelector('[data-fenx-overlay]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('input');
      if (!input) return;
      const val = parseInt(input.value || '1', 10);
      input.value = Math.max(1, val - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('input');
      if (!input) return;
      const val = parseInt(input.value || '1', 10);
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const slideshows = document.querySelectorAll('[data-fenx-slideshow]');

  slideshows.forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('[data-slide]');
    const dots = slideshow.querySelectorAll('[data-slide-dot]');
    const prevBtn = slideshow.querySelector('[data-slide-prev]');
    const nextBtn = slideshow.querySelector('[data-slide-next]');

    if (!slides.length) return;

    let current = 0;
    let interval = null;
    const autoplay = slideshow.dataset.autoplay === 'true';
    const speed = parseInt(slideshow.dataset.speed || '5', 10) * 1000;

    function updateSlides(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      current = index;
    }

    function nextSlide() {
      const next = (current + 1) % slides.length;
      updateSlides(next);
    }

    function prevSlide() {
      const prev = (current - 1 + slides.length) % slides.length;
      updateSlides(prev);
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      interval = setInterval(nextSlide, speed);
    }

    function stopAutoplay() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', function () {
        updateSlides(index);
        startAutoplay();
      });
    });

    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    updateSlides(0);
    startAutoplay();
  });
});